(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.product-page').forEach(function (root) {
    var lightbox = root.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var lightboxImages = lightbox.querySelectorAll('.product-lightbox__image');

    root.querySelectorAll('[data-lightbox-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        lightbox.showModal();
        document.documentElement.style.overflow = 'hidden';
        var target = lightboxImages[Number(button.dataset.lightboxOpen)];
        lightbox.scrollTop = target ? target.offsetTop : 0;
      });
    });

    // clicking an image or the × closes; Esc is handled by <dialog> itself
    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('.product-lightbox__image, [data-lightbox-close]')) {
        lightbox.close();
      }
    });

    lightbox.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
    });
  });

  document.querySelectorAll('.product-page').forEach(function (root) {
    var variantsEl = root.querySelector('[data-variants]');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var addLabel = addButton ? addButton.querySelector('[data-add-label]') : null;
    var groups = root.querySelectorAll('.product-info__values');

    function currentSelection() {
      var selection = [];
      groups.forEach(function (group) {
        var selected = group.querySelector('.is-selected');
        selection.push(selected ? selected.dataset.value : null);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          return value === selection[i];
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    groups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var button = event.target.closest('.product-info__value');
        if (!button || button.disabled) return;

        group.querySelectorAll('.product-info__value').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        button.classList.add('is-selected');

        updateForVariant(findVariant(currentSelection()));
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
